/**
 * 比较app版本号
 * @param curV 当前版本号
 * @param reqV 比较版本号
 * @return 比较后结果，当前版本号大于等于比较版本号：true，当前版本号小于比较版本号: false, 版本号输入错误：curV error，reqV error
 */
export const versionCompare = (curV: string, reqV: string): boolean | string => {
  // 将两个版本号拆成数字
  const arr1 = curV.split('.');
  const arr2 = reqV.split('.');
  // 取最小长度
  const minLength = Math.min(arr1.length, arr2.length);
  let diff = 0;
  // 版本号位数
  let curIndex = 0;
  let reqIndex = 0;
  while (curIndex < arr1.length) {
    // 判断每一位是否为正整数
    if (!/^\+?[0-9][0-9]*$/.test(arr1[curIndex])) {
      return 'curV error';
    }
    curIndex++;
  }
  while (reqIndex < arr2.length) {
    if (!/^\+?[0-9][0-9]*$/.test(arr2[reqIndex])) {
      return 'reqV error';
    }
    reqIndex++;
  }
  // 比较版本号每一位，当对比不同时跳出循环
  for (let i = 0; i < minLength; i++) {
    if ((Number(arr1[i]) - Number(arr2[i])) !== 0) {
      diff = Number(arr1[i]) - Number(arr2[i]);
      break;
    } else {
      diff = Number(arr1[i]) - Number(arr2[i]);
    }
  }
  diff = (diff !== 0) ? diff : (arr1.length - arr2.length);
  // 若curV大于reqV，则返回true
  return diff >= 0;
};
